export default {
  title: "后台管理系统",// 程序名称
  closeOnClickModal: true, // 是否点击modal关闭
  closeOnPresEscape: true, // 是否esc关闭dialog
  dialogShowClose: false,
  loading: false,
  // 咨询的分类
  articleClassify: [{
    value: "",
    label: "全部"
  },
  // {
  //   value: "1",
  //   label: "新闻动态"
  // },
  // {
  //   value: "2",
  //   label: "医药咨询"
  // },
  // {
  //   value: "3",
  //   label: "监管信息"
  // },
  {
    value: "34",
    label: "系统通知"
  }, {
    value: "418",
    label: "新品消息"
  }, {
    value: "417",
    label: "上涨通知"
  }, {
    value: "440",
    label: "业务员消息"
  }],
  // app跳转类型维护
  APP_TYPE_LIST: [
    { id: '0', name: '无跳转' },
    { id: '1', name: '商品详情' },
    // { id: '2', name: '跳转模块' },
    // { id: '3', name: '网页链接' },
    { id: '4', name: '商品分类' },
    // { id: '5', name: '专区商品' },
    { id: '6', name: '首页视频' },
    { id: '7', name: '首页图文' },
  ],
  // 订单状态
  ORDER_STATUS: [
    {
      value: "99",
      label: "全部",
    },
    {
      value: "1",
      label: "待付款",
    },
    {
      value: "2",
      label: "已审核",
    },
    {
      value: "3",
      label: "待处理",
    },
    {
      value: "4",
      label: "已出库",
    },
    {
      value: "5",
      label: "已发货",
    },
    {
      value: "6",
      label: "已完成",
    },
    {
      value: "10",
      label: "已退货",
    },
    {
      value: "11",
      label: "已退款",
    },
    {
      value: "0",
      label: "已删除",
    },
  ],
  // 内置专区列表
  ZONE_LIST: [
    { label: '领券中心', value: 'getCoupon' },
    { label: '限时抢购', value: 'flashSale' },
    { label: '促销专区', value: 'prom' },
    { label: '品牌专区', value: 'brand' },
    { label: '组合专区', value: 'goodsGroup' },
    // { label: '中药专区', value: 'zyzq' },
    { label: '拼团专区', value: 'spellGroup' },
    { label: '商品横幅(非专区)', value: 'expert' },
    { label: '预售专区', value: 'presell' },
    // { label: '集采专区', value: 'focusBuy' },
  ],//内置专区列表数据，很多地方都用到
  /**促销类型 */
  PROM_TYPE: [
    { label: '抢购', value: 'DQG' },
    { label: '折扣', value: 'DZK' },
    { label: '买赠', value: 'DMZ' },
    { label: '满减', value: 'DMJ' },
    { label: '换购', value: 'DHG' },
    { label: '组合', value: 'GZH' }
  ],
  nations: ['汉族', '蒙古族', '回族', '藏族', '维吾尔族', '苗族', '彝族', '壮族', '布依族', '朝鲜族', '满族', '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族', '黎族', '僳僳族', '佤族', '畲族', '高山族', '拉祜族', '水族', '东乡族', '纳西族', '景颇族', '柯尔克孜族', '土族', '达斡尔族', '仫佬族', '羌族', '布朗族', '撒拉'],
  userInfo: { // 用户信息和token应该从localStroage中获取
    adminId: '', // 管理员ID 
    organId: '', // 机构ID
    userName: '',
    pass: '',
    name: '',
    roleId: '',
    roleType: '',
    sex: '',
    status: '',
    tel: ''
  },
  limitPath: '',
  // 默认的数据，后台接口进行了替换
  citys: [],
  buttonPermissions: {} // 初始化为空对象，避免 undefined
}